import { admin2 } from './instance'

const baseUrl = (shopId) => `/${shopId}/orgSalesRecord`

/**
 * 取得總部銷售紀錄列表 admin.orgSalesRecord.find
 * @param {Object} params - 查詢參數
 * @param {string} params.shopId - 商店ID
 * @param {string} [params.orderNo] - 銷售紀錄編號
 * @param {string} [params.phone] - 電話號碼
 * @param {string} [params.BranchId] - 分店ID
 * @param {string} [params.ShopId] - 指定查詢的商店ID (實際上要篩的分店ID)
 * @param {number} [params.start=0] - 查詢起始
 * @param {number} [params.limit=20] - 查詢筆數
 * @returns {Promise<Array>} 銷售紀錄列表
 */
export const GetSalesRecord = async ({
  shopId,
  orderNo,
  phone,
  BranchId,
  ShopId,
  start,
  limit,
}) => {
  return await admin2({
    method: 'GET',
    url: baseUrl(shopId),
    params: {
      orderNo,
      phone,
      BranchId,
      ShopId: ShopId,
      start,
      limit,
    },
  })
}

/**
 * 取得總部銷售紀錄總數 admin.orgSalesRecord.count
 * @param {Object} params - 查詢參數
 * @param {string} params.shopId - 商店ID
 * @param {string} [params.orderNo] - 銷售紀錄編號
 * @param {string} [params.phone] - 電話號碼
 * @param {string} [params.BranchId] - 分店ID
 * @param {string} [params.ShopId] - 指定查詢的商店ID (實際上要篩的分店ID)
 * @returns {Promise<number>} 銷售紀錄總數
 */
export const GetSalesRecordCount = async ({
  shopId,
  orderNo,
  phone,
  BranchId,
  ShopId,
}) => {
  return await admin2({
    method: 'GET',
    url: `${baseUrl(shopId)}/count`,
    params: {
      orderNo,
      phone,
      BranchId,
      ShopId: ShopId,
    },
  })
}

/**
 * 取得單筆總部銷售紀錄 admin.orgSalesRecord.findOne
 * @param {Object} params - 查詢參數
 * @param {string} params.shopId - 商店ID
 * @param {string} params.id - 銷售紀錄ID
 * @returns {Promise<Object>} 銷售紀錄詳細資料
 */
export const FindSalesRecord = async ({
  shopId,
  id,
}) => {
  return await admin2({
    method: 'GET',
    url: `${baseUrl(shopId)}/${id}`,
  })
}

/**
 * 取得總部銷售紀錄的事件行銷獎勵紀錄 admin.orgSalesRecord.findEventPlaybookAwardRecords
 * @param {Object} params - 查詢參數
 * @param {string} params.shopId - 商店ID
 * @param {string} params.id - 銷售紀錄ID
 * @returns 事件行銷獎勵紀錄列表
 * @example
 * // 回傳格式
 * {
 *   "eventPlaybookAwardRecords": [
 *     {
 *       "id": "award-record-uuid",
 *       "status": "sent",
 *       "awardType": "point",
 *       "awardAmount": 20,
 *       "shopPointKey": "metro_point",
 *       "sendAt": "2025-11-05T01:42:33.000Z",
 *       "isSend": true,
 *       "awardNote": "單筆消費滿額贈送",
 *       "EventPlaybook": {
 *         "id": "playbook-uuid",
 *         "name": "單筆消費滿 200 贈 10 點"
 *       }
 *     }
 *   ]
 * }
 */
export const FindOrgEventPlaybookAwardRecord = async ({
  shopId,
  id,
}) => {
  return await admin2({
    method: 'GET',
    url: `${baseUrl(shopId)}/${id}/eventPlaybookAwardRecords`,
  })
}
